import logo from '@/assets/landing/images/logo.svg';
import { ComplianceLinks } from '@/components/ComplianceLinks';

export function SiteFooter() {
  return (
    <footer className="bg-white py-12">
      <div className="landing-container">
        <div className="border-b border-gray-200 pb-8 mb-8">
          <div className="flex items-center space-x-4">
            <img src={logo} alt="Culture Monitor Logo" className="w-8 h-8" />
            <div>
              <p className="font-medium text-gray-900">Conheça a LIVE</p>
              <a
                href="mailto:newbusiness@live.tt"
                className="text-gray-900 underline hover:text-gray-700"
              >
                newbusiness@live.tt
              </a>
            </div>
          </div>
        </div>
        <div className="flex flex-col-reverse gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-gray-600 text-sm">
            © {new Date().getFullYear()} Culture Monitor. Todos os direitos reservados
          </p>
          <ComplianceLinks
            className="sm:justify-end"
            linkClassName="text-gray-900 text-sm font-medium hover:text-gray-600"
          />
        </div>
      </div>
    </footer>
  );
}
